'use strict';

const React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    const n = Object.create(null, { [Symbol.toStringTag]: { value: 'Module' } });
    if (e) {
        for (const k in e) {
            if (k !== 'default') {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: () => e[k]
                });
            }
        }
    }
    n.default = e;
    return Object.freeze(n);
}

const React__namespace = /*#__PURE__*/_interopNamespace(React);

const SvgNavGridView = (props) => React__namespace.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React__namespace.createElement("path", { fill: "#2D2E2E", fillRule: "evenodd", d: "M11 11H3V3h8v8ZM9 5H5v4h4V5ZM11 21H3v-8h8v8Zm-2-6H5v4h4v-4ZM13 21h8v-8h-8v8Zm2-6h4v4h-4v-4ZM21 11h-8V3h8v8Zm-2-6h-4v4h4V5Z", clipRule: "evenodd" })
);

module.exports = SvgNavGridView;
//# sourceMappingURL=NavGridView.cjs.js.map
